if (new URLSearchParams(location.search).has('prep_lab')) {
  const metrics = {mode:'Unthrottled browser lab; not field Core Web Vitals',lcpMs:null,cls:0};
  const output = document.createElement('output');
  output.id = 'prep-lab-metrics';
  output.hidden = true;
  document.body.append(output);
  const report = () => {
    const nav = performance.getEntriesByType('navigation')[0];
    const fcp = performance.getEntriesByName('first-contentful-paint')[0];
    output.textContent = JSON.stringify({...metrics,width:innerWidth,fcpMs:fcp?.startTime ?? null,ttfbMs:nav?.responseStart ?? null,domContentLoadedMs:nav?.domContentLoadedEventEnd ?? null,resources:performance.getEntriesByType('resource').map(r=>({name:r.name.split('?')[0],durationMs:r.duration,transferSize:r.transferSize}))});
  };
  new PerformanceObserver(list => { for (const e of list.getEntries()) metrics.lcpMs=e.startTime; report(); }).observe({type:'largest-contentful-paint',buffered:true});
  new PerformanceObserver(list => { for (const e of list.getEntries()) if(!e.hadRecentInput) metrics.cls+=e.value; report(); }).observe({type:'layout-shift',buffered:true});
  addEventListener('load',report);
  setTimeout(report,3000);
}
